export * from '../src/components/wui-loading-hexagon/index.js';
//# sourceMappingURL=wui-loading-hexagon.js.map